import { useRef } from "react";
import BookPlaceHolder from "../images/bookCover.svg";

export const ImageUpload = ({
  url = "",
  direction = "column",
  maxImgWidth = 124,
  maxImgHeight = 160,
  handleImageUpdate,
}) => {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    e.preventDefault();
    const imgFile = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxWidth = maxImgWidth; // desired width
        const maxHeight = maxImgHeight; // desired height

        let width = img.width;
        let height = img.height;

        // Calculate the new dimensions while maintaining the aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        // Draw the image on the canvas
        ctx.drawImage(img, 0, 0, width, height);

        // Get the data URL of the resized image
        const imgDataUrl = canvas.toDataURL("image/jpeg", 1); // quality factor between 0 and 1

        // Update the state with the resized image data
        handleImageUpdate(imgDataUrl);
      };
    };

    if (imgFile) reader.readAsDataURL(imgFile);
  };

  return (
    <div
      className={`d-flex flex-${direction} align-items-center justify-content-around gap-3`}
    >
      <img
        src={url || BookPlaceHolder}
        alt="book icon here"
        width={maxImgWidth}
        height={maxImgHeight}
        style={{ objectFit: "fill" }}
        className="rounded-2"
      />
      <button
        type="button"
        style={{
          padding: "8px",
          background: "white",
          borderRadius: 4,
          border: "1px solid black",
          fontSize: "14px",
          width: "7rem",
        }}
        onClick={() => fileInputRef.current.click()}
      >
        {url ? "Update Image" : "Upload Image"}
      </button>
      <input
        type="file"
        className="d-none"
        ref={fileInputRef}
        accept="image/gif, image/jpeg, image/png, image/*"
        onChange={handleChange}
      />
    </div>
  );
};
